import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Button } from 'gdpp-components/dist/cjs/components/atoms'
import '@fil-global/gds-webcomponents/fil-icon/fil-icon.component'

import Input from '../../atoms/Input'
import Select from '../../atoms/Select'

import './style.scss'

const Pagination = ({ id, dropdown, totalItemsNum, defaultItemsCount, callback, extraClasses }) => {
  const getTotalPagesNum = (newItemsCount) => {
    return Math.ceil(totalItemsNum / newItemsCount)
  }

  const [itemsPerPage, setItemPerPage] = useState(defaultItemsCount)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPagesNum, setTotalPageNum] = useState(getTotalPagesNum(defaultItemsCount))

  const handlePageNumChange = (pageNum) => {
    setCurrentPage(pageNum)
    callback({
      currentPage: pageNum
    })
  }

  const handleItemNumChange = (itemsCount) => {
    const newTotalPagesNum = getTotalPagesNum(itemsCount)
    const changedCurrentPageNum = currentPage > newTotalPagesNum ? newTotalPagesNum : currentPage
    setTotalPageNum(newTotalPagesNum)
    setCurrentPage(changedCurrentPageNum)
    setItemPerPage(itemsCount)
    callback({
      itemsCount,
      currentPage: changedCurrentPageNum
    })
  }

  const previousPage = () => {
    const newPage = currentPage - 1 < 1 ? 1 : currentPage - 1
    handlePageNumChange(newPage)
  }

  const nextPage = () => {
    const newPage = currentPage + 1 > totalPagesNum ? totalPagesNum : currentPage + 1
    handlePageNumChange(newPage)
  }

  return (
    <section id={id} className={classnames('fil-pagination-wrapper', extraClasses)}>
      {dropdown && dropdown.options && dropdown.options.length && (
        <div className="fil-pagination__dropdown">
          <span>{dropdown.label}:</span>
          <Select
            id={`pagination_${id}_dropdown`}
            value={itemsPerPage}
            // options={dropdown.options}
            options={JSON.stringify(dropdown.options)}
            onChange={(e) => {
              handleItemNumChange(parseInt(e.value, 10))
            }}
          />
        </div>
      )}
      <div className="fil-pagination__buttons">
        <Button
          kind="tertiary"
          size="standard"
          label="Previous"
          iconPosition="left"
          iconSize="16"
          icon="custom-arrow-left"
          onClick={(e) => {
            previousPage(e)
          }}
          disabled={currentPage === 1}
        />
        {/* Mobile Button */}
        <Button
          kind="tertiary"
          size="standard"
          label=""
          iconPosition="left"
          iconSize="16"
          icon="custom-arrow-left"
          extraClasses="fil-pagination__buttons-mobile"
          onClick={(e) => {
            previousPage(e)
          }}
          disabled={currentPage === 1}
        />
        <span className="fil-pagination__buttons-input">
          <Input
            onChange={(e) => {
              let { value } = e
              if (value > totalPagesNum) {
                value = totalPagesNum
              } else if (value < 1) {
                value = 1
              }
              handlePageNumChange(value)
            }}
            value={currentPage}
          />
          of {totalPagesNum}
        </span>
        <Button
          kind="tertiary"
          size="standard"
          label="Next"
          iconPosition="right"
          iconSize="16"
          icon="custom-arrow-right"
          onClick={(e) => {
            nextPage(e)
          }}
          disabled={currentPage === totalPagesNum}
        />
        {/* Mobile Button */}
        <Button
          kind="tertiary"
          size="standard"
          label=""
          iconPosition="right"
          iconSize="16"
          icon="custom-arrow-right"
          extraClasses="fil-pagination__buttons-mobile"
          onClick={(e) => {
            nextPage(e)
          }}
          disabled={currentPage === totalPagesNum}
        />
      </div>
    </section>
  )
}

Pagination.propTypes = {
  id: PropTypes.string.isRequired,
  totalItemsNum: PropTypes.number.isRequired,
  dropdown: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number,
    options: PropTypes.array
  }),
  extraClasses: PropTypes.string,
  defaultItemsCount: PropTypes.number,
  callback: PropTypes.func
}

Pagination.defaultProps = {
  dropdown: {},
  extraClasses: '',
  defaultItemsCount: 0,
  callback: () => {}
}

export default Pagination
